<template>
  <standard-layout title="Not Found">
    <v-container fluid>
      <v-row justify="center" align="center" class="fill-height">
        <v-col cols="12" md="8" class="text-center">
          <h1 class="text-h3 mb-4">Page Not Found</h1>
          <p class="text-body-1">The page you're looking for does not exist.</p>
          <v-btn
            color="primary"
            class="mt-4"
            @click="$router.push('/')"
          >
            Back to Home
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </standard-layout>
</template>

<script>
import StandardLayout from "@/components/standard-layout.vue";

export default {
  components: {
    StandardLayout
  }
};
</script>
